import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from '../../utils/httpsRequest';

export const fetchUsers = createAsyncThunk('user/fetchUsers', async () => {
    return httpRequest(`${BASE_URL}/ManageUser`);
});

const userSlice = createSlice({
    name: 'user',
    initialState: {
        loading: false,
        user: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetState } = userSlice.actions;
export default userSlice.reducer;
